import { Criticality } from './utils/types';

const criticalityConfig: Record<Criticality, { className: string; color: string }> = {
    [Criticality.SCHEDULE_SERVICE]: {
        className: 'uikit-icon icon-error-sign',
        color: 'text-color-danger',
    },
    [Criticality.SERVICE_SOON]: {
        className: 'uikit-icon icon-warning-sign',
        color: 'text-color-warning',
    },
    [Criticality.INFORMATION]: {
        className: 'uikit-icon icon-info-sign',
        color: 'text-color-info',
    },
};

const Icon = ({ criticality, size = 18 }: { criticality: Criticality; size?: number }) => {
    const config = criticalityConfig[criticality];
    return <span className={`${config.className} ${config.color}`} style={{ fontSize: size }} />;
};

export default Icon;
